import { useEffect, useRef } from "react";
import { WS_BASE, getToken } from "@/lib/api";

/**
 * Subscribe to /ws/comments/{case_id} and invoke onComment(comment) for each
 * incoming message. Handles connection lifecycle, auth via token query, and
 * logs unexpected errors instead of swallowing them silently.
 */
export default function useCaseWebSocket(caseId, onComment) {
  const wsRef = useRef(null);
  const handlerRef = useRef(onComment);
  handlerRef.current = onComment;

  useEffect(() => {
    const token = getToken();
    if (!token || !caseId) return undefined;

    const url = `${WS_BASE}/ws/comments/${caseId}?token=${encodeURIComponent(token)}`;
    let ws;
    try {
      ws = new WebSocket(url);
    } catch (err) {
      console.error("WebSocket construction failed:", err);
      return undefined;
    }
    wsRef.current = ws;

    ws.onmessage = (ev) => {
      try {
        const msg = JSON.parse(ev.data);
        if (msg.type === "comment") handlerRef.current?.(msg.comment);
      } catch (err) {
        console.warn("WebSocket message parse error:", err);
      }
    };
    ws.onerror = (ev) => {
      console.warn("WebSocket error event:", ev?.type || ev);
    };

    return () => {
      try { ws.close(); }
      catch (err) { console.warn("WebSocket close error:", err); }
    };
  }, [caseId]);

  return wsRef;
}
